var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.disabled
    ? _c("div", { staticClass: "pb-0 group-title-wrapper" }, [
        _c("div", { staticClass: "type-label" }, [_vm._v("Series")]),
        _vm._v(" "),
        _c("div", { staticClass: "group-title" }, [
          _c("div", { staticClass: "group-title" }, [
            _c(
              "h1",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editTitle,
                    expression: "!editTitle"
                  }
                ],
                staticClass:
                  "mb-0 exclude-outside-click edit-d-title project-title",
                on: { click: _vm.activateTitleField }
              },
              [_vm._v(_vm._s(_vm.socialSeriesDetail.title))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editTitle,
                  expression: "editTitle"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.socialSeriesDetail.title,
                  expression: "socialSeriesDetail.title"
                },
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.clickOutsideTitle,
                  expression: "clickOutsideTitle"
                }
              ],
              ref: "editTitleRef",
              staticClass:
                "form-control mb-3 title-field exclude-outside-click h1",
              attrs: { type: "text", placeholder: "Social Media Series..." },
              domProps: { value: _vm.socialSeriesDetail.title },
              on: {
                change: function($event) {
                  return _vm.updateSocialSeries()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.socialSeriesDetail, "title", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }